import { styled } from "@mui/system";
import { Box } from "@mui/material";

export const Gapper = styled(Box, {
  shouldForwardProp: (prop) =>
    !["gap", "styles", "flexDirection", "alignItems"].includes(prop),
})(({ gap = 30, styles, theme, flexDirection = "column", alignItems }) => ({
  display: "flex",
  flexDirection,
  width: "100%",
  gap,
  justifyContent: "center",
  ...(alignItems != null && { alignItems }),
  ...(typeof styles === "function" ? styles({ theme }) : styles),
}));

export const figmaLetterSpacing = (fontSizePx, letterSpacingPercent) =>
  `${(fontSizePx * letterSpacingPercent) / 100}px`;

export const getInitials = (name) => {
  if (!name) return "";

  const nameParts = name.trim().split(/\s+/);

  if (nameParts.length >= 2) {
    const firstName = nameParts[0];
    const lastName = nameParts[nameParts.length - 1];
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  }

  if (nameParts.length === 1) {
    return nameParts[0][0].toUpperCase();
  }

  return "";
};
